import { render, staticRenderFns } from "./LockOff.vue?vue&type=template&id=01512146"
import script from "./LockOff.vue?vue&type=script&lang=js"
export * from "./LockOff.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports